VjsAdmin.VjsAdminUserLoginHistory = (function () {
    const $table = $('#user-loginhistory-table');

    const initTable = function () {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#user-loginhistory-table',
            formatNoMatches() {
                return 'No records for the selected user';
            },
            url: Slim.Router.pathFor('admin.user.loginhistory.list'),
            idField: 'user_id',
            sortName: 'date_login',
            sortOrder: 'DESC',
            search: false,
            columns: [
                {
                    title: 'Username',
                    field: 'username',
                    align: 'left',
                    valign: 'middle',
                },
                {
                    title: 'First Name',
                    field: 'first_name',
                    align: 'left',
                    valign: 'middle',
                },
                {
                    title: 'Last Name',
                    field: 'last_name',
                    align: 'left',
                    valign: 'middle',
                },
                {
                    title: 'IP Addres',
                    field: 'ip_address',
                    align: 'right',
                    valign: 'middle',
                },
                {
                    title: '<i class="fa-regular fa-clock" aria-hidden="true"></i> Time Spent',
                    field: 'time_spent',
                    align: 'right',
                    valign: 'middle',
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Date',
                    field: 'date_login',
                    align: 'center',
                    valign: 'middle',
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;
                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    VjsAdmin.convertDateRow(result, 'MM/DD/YYYY');
                });
                return formattedResult;
            },
            queryParams() {
                const myParams = {};
                myParams.id = $table.attr('data-user-id');
                return myParams;
            },
        });
    };

    return {
        init: initTable(),
    };
}());
